import { useMemo } from "react";
import { LifeCycles } from "single-spa";
import { ReactAppOrParcel } from "single-spa-react";

export const multiMounter = <ExtraProps = {}>(id: string, mountInfo: (element: HTMLElement) => ReactAppOrParcel<ExtraProps>): LifeCycles<ExtraProps> => {
    const elements = Array.from(document.querySelectorAll('#single-spa-application\\\:' + id)) as HTMLElement[];
    const mountData = elements.map(mountInfo);
    return {
        bootstrap: mountData.map(m => m.bootstrap),
        mount: mountData.map(m => m.mount),
        unmount: mountData.map(m => m.unmount),
        update: async () => { }
    }
}


export function useMultiPreloadState<T>(id: string): T {
    return useMemo(() => {
        const preloadState = (window as any).app.preloadState[id];
        if (Array.isArray(preloadState)) {
            return preloadState.shift() as T;
        }
        return preloadState as T;
    }, []);
}